const STORAGE_KEY = "label_settings";

const getDefaultState = () => ({
  productsToPrint: [],
  labelWidth: 57,
  labelHeight: 32,
  marginX: 2,
  marginY: 2,
  nameFontSize: 14,
  priceFontSize: 16,
  barcodeSize: 20,
  checkboxes: {
    Price: true,
    Name: true,
    Barcode: true,
    debugMode: false,
  },
});

const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
const defaults = getDefaultState();
const savedCheckboxes = { ...(saved?.checkboxes || {}) };
delete savedCheckboxes.threeLineName;

const initialState = saved
  ? {
      ...defaults,
      ...saved,
      checkboxes: {
        ...defaults.checkboxes,
        ...savedCheckboxes,
      },
    }
  : defaults;

export default {
  namespaced: true,
  state: initialState,

  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, payload);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },

    ADD_PRODUCT(state, item) {
      const index = state.productsToPrint.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        state.productsToPrint[index].quantityToPrint += item.quantityToPrint;
      } else {
        state.productsToPrint.push({ ...item });
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },

    UPDATE_PRODUCT(state, updatedItem) {
      const index = state.productsToPrint.findIndex(
        (i) => i.id === updatedItem.id
      );
      if (index !== -1) {
        state.productsToPrint[index] = updatedItem;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      }
    },

    DELETE_PRODUCT(state, id) {
      state.productsToPrint = state.productsToPrint.filter((p) => p.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },

    CLEAR_PRODUCTS(state) {
      state.productsToPrint = [];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },

    UPDATE_SETTING(state, { key, value }) {
      state[key] = value;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
  },

  actions: {
    resetSettings({ commit, state }) {
      commit("SET_STATE", {
        ...getDefaultState(),
        productsToPrint: state.productsToPrint,
      });
    },
  },
};
